import { createContext } from 'react'

export type ToastTone = 'success' | 'error' | 'warning' | 'info'

export type ToastOptions = {
  title: string
  description?: string
  tone?: ToastTone
  /** Milliseconds. Pass 0 to require an explicit dismiss (use for errors worth reading). */
  duration?: number
}

export type Toast = ToastOptions & { id: string }

export type ToastContextValue = {
  /** Returns the toast id so a long-running action can dismiss its own message. */
  toast: (options: ToastOptions) => string
  dismiss: (id: string) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
